import styled from '@emotion/styled'

import { calcRem } from 'component-library/__styling/style-functions'
import { colors, metrics, fonts } from 'component-library/__styling/settings'
import { StyledLink as CardTextInteractions } from 'component-library/cards/CardText/CardTextInteractions.styled'
import { SponsoredLabel } from '../SponsoredLabel/SponsoredLabel'
import { CardHeadline } from 'component-library/cards/CardText/CardHeadline'
import { styledKickerClassName } from 'component-library/cards/Kicker/Kicker.styled'
import { transition } from 'component-library/__styling/style-mixins'
import { TextClassName } from '../SponsoredLabel/SponsoredLabel.styled'

export const StyledRippleCard = styled(CardTextInteractions)(({ theme }) => ({
    textDecoration: 'none',
    display: 'flex',
    width: '100%',
    position: 'relative',
    textDecorationSkipInk: 'auto',
    border: `1px solid ${colors.thewest.greyHippo}`,

    '&:focus': {
        [`.${styledKickerClassName}`]: {
            color: colors.white,
            background: colors.black,
        },

        [`& picture`]: {
            '&::after': {
                borderColor: colors.thewest.greyGorilla,
            },
        },
    },

    '&:hover picture': {
        '&::after': {
            borderColor: theme.sectionValues.primaryColor,
        },
    },
}))

StyledRippleCard.displayName = 'RippleCard'

export const StyledPicture = styled('picture')({
    position: 'relative',
    display: 'block',
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: 200,
    minWidth: 150,

    '&::after': {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '100%',
        content: `''`,
        background: 'transparent',
        borderWidth: '0 0 4px 0',
        borderStyle: 'solid',
        borderColor: 'transparent',
        ...transition({ properties: ['height', 'border-color'] }),
    },
})
StyledPicture.displayName = 'Picture'

export const StyledImage = styled('img')({
    width: '100%',
    height: 'auto',
    display: 'block',
})

export const StyledText = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: calcRem(theme.cards.outerMargin),
}))
StyledText.displayName = 'TextWrapper'

export const StyledCardHeadline = styled(CardHeadline)(({ theme }) => ({
    flex: 'none',

    [`& .${styledKickerClassName}`]: {
        lineHeight: 1,
        color: colors.white,
        background: theme.sectionValues.primaryColor,
        padding: calcRem(4),
        fontSize: calcRem(11),
        fontFamily: fonts.thewest.sansSerif,
        textTransform: 'uppercase',
    },
}))

export const StyledSponsoredLabel = styled(SponsoredLabel)({
    justifySelf: 'flex-end',
    fontWeight: 400,
    fontSize: calcRem(13),
    marginTop: calcRem(metrics.thewest.margins.xs),

    [`& .${TextClassName}`]: {
        color: colors.thewest.greyElephant,
    },
})
